







































































































































































































































































import { ElForm } from "element-ui/types/form";
import { Component, Vue } from "vue-property-decorator";
import {
  getNewsList,
  getSurplusList,
  uploadImg,
  addNews,
  editNews,
  deleteNewsById,
  getNewsTypeFullList,
} from "@/serve/news/news";
import { getTenantData } from "@/serve/medicalAppointment/institutionManage";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
interface AddFormData {
  title: string;
  editor: string;
  mainImage: string;
  contentText: string;
  categoryId: string;
  id?: string | number | null;
}
@Component({
  name: "SchemeManage",
  components: { quillEditor },
})
export default class SchemeManage extends Vue {
  public fileList = [
    {
      name: "",
    },
  ];
  public reportMedical = [];
  public falseReport = [];
  public personMedical = [];
  public isSelect = false;
  public selectDisable = false;
  public selectMedical = "";
  public isEditing = false;
  public toolbar = [
    ["bold", "italic", "underline", "strike"],
    ["blockquote", "code-block"],
    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ["clean"],
    ["image", "video"],
  ];
  public rules = {
    title: [{ required: true, message: "请填写文章标题", trigger: "blur" }],
    editor: [
      { required: true, message: "请填写文章作者", trigger: "blur" },
      { min: 1, max: 10, message: "作者长度在1到10个字符", trigger: "change" },
    ],
    mainImage: [{ required: true, message: "请上传封面", trigger: "blur" }],
    categoryId: [{ required: true, message: "请选择文章类别", trigger: "blur" }],
  };
  public editorOption = {
    placeholder: "请输入正文，可插入图片和视频",
    modules: {
      toolbar: {
        container: this.toolbar,
        handlers: {
          image: (value: any) => {
            if (value) {
              (document.querySelector(
                ".avatar-uploader input"
              ) as HTMLElement).click();
            }
          },
        },
      },
    },
  };
  public currentPage4 = 1;
  public formLabelWidth = "120px";
  public str = "";
  public type = "添加";
  public form = {
    title: "",
    editor: "",
    mainImage: "",
    current: 1,
    size: 10,
    categoryId: "",
    tenantId: "",
  };
  public imgUrls = "";
  public detailContent = {};
  public tableData: any = [];
  public formData: AddFormData = {
    title: "",
    editor: "",
    mainImage: "",
    contentText: "",
    categoryId: "",
  };
  public file!: File;
  public imgUrl = "";

  public isAdmin = sessionStorage.getItem("isAdmin");
  public tenantName = "";
  public restaurants = [];
  public created() {
    this.getDiseaseList();
    this.getCategoryList();
  }
  public mounted() {
    this.getTenantData();
  }
  public categoryList: any = [];
  getCategoryList() {
    const params = {
      current: 1,
      size: 999,
    };
    getNewsTypeFullList(params).then((res) => {
      this.categoryList = res.data.records;
    });
  }
  public async getTenantData(): Promise<void> {
    const res = await getTenantData({ size: 100000, current: 1 });
    this.restaurants = res.data.records;
  }
  public handleSelect(e: any) {
    if (Object.keys(e).length > 0) this.form.tenantId = e.tId;
    else this.form.tenantId = "";
  }
  public async querySearch(queryString: any, cb: any) {
    const restaurants = this.restaurants;
    const newArr: any = [];
    restaurants.forEach((x: any) => {
      if (x.name.includes(queryString)) {
        newArr.push({ value: x.name, tId: x.id });
      }
    });
    cb(newArr);
  }
  public async handleAvatarSuccess(res: { file: File }) {
    const imgs = new FormData();
    imgs.append("file", res.file);
    const file = await uploadImg(imgs);
    this.formData.mainImage = String(file.data);
  }

  public resetForm(formName: string) {
    (this.$refs[formName] as ElForm).resetFields();
    this.currentPage4 = 1;
    this.getDiseaseList();
  }
  public async getDiseaseList() {
    this.$changNull(this.form);
    const res = await getNewsList(this.form);
    this.tableData = res.data;
  }
  public async getSurplus() {
    const trueres = await getSurplusList({ type: "true" });
    this.reportMedical = trueres.data;
    const falseres = await getSurplusList({ type: "false" });
    this.falseReport = falseres.data;
  }
  public addSchema() {
    this.type = "添加";
    this.selectDisable = false;
    this.formData = {
      title: "",
      editor: "",
      mainImage: "",
      contentText: "",
      categoryId: "",
    };
    this.isEditing = true;
    this.$nextTick(() => {
      const form = this.$refs.formData as ElForm;
      if (form) {
        form.clearValidate();
      }
    });
  }
  public hanlderCancel() {
    const form = this.$refs.formData as ElForm;
    if (form) {
      form.resetFields();
    }
    this.formData.contentText = "";
    this.formData.categoryId = "";
    this.selectMedical = "";
    this.personMedical = [];
    this.isSelect = false;
    this.isEditing = false;
  }
  public async editRow(_id: number, row: any): Promise<void> {
    this.formData = { ...row };
    this.type = "编辑";
    this.selectDisable = true;
    this.isEditing = true;
  }
  public onSubmit(): void {
    this.getDiseaseList();
  }
  public async deleteRow(id: number, item: any): Promise<void> {
    (this as any).$messageBox
      .confirm(`您确定是否删除标题为${item.title}的这一条数据`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(async () => {
        const res = await deleteNewsById(id);
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getDiseaseList();
        }
      });
  }
  public handleSizeChange(val: any): void {
    this.form.size = val;
    this.getDiseaseList();
  }
  public handleCurrentChange(val: any): void {
    this.form.current = val;
    this.getDiseaseList();
  }
  public beforeAvatarUpload(file: File) {
    const isJPG = file.type === "image/jpeg";
    const isPNG = file.type === "image/png";
    const isPG = isJPG || isPNG;
    const isLt2M = file.size / 1024 / 1024 < 1;
    if (!isPG) {
      this.$message.error("上传头像图片只能是 JPG/PNG格式!");
    }
    if (!isLt2M) {
      this.$message.error("上传头像图片大小不能超过 2MB!");
    }
    return isPG && isLt2M;
  }
  public async uploadFunc(res: { file: File }) {
    this.file = res.file;
    this.imgUrl = URL.createObjectURL(res.file);
    const imgs = new FormData();
    imgs.append("file", this.file);
    const Img = await uploadImg(imgs);
    const quill = (this.$refs.myQuillEditor as any).quill;
    if (Img.code === 200 && Img.data !== null) {
      const length = quill.getSelection().index;
      quill.insertEmbed(length, "image", Img.data);
      quill.setSelection(length + 1);
    } else {
      this.$message.error("图片插入失败");
    }
  }
  public async handlerSubmit(formName: string) {
    (this.$refs[formName] as ElForm).validate(async (valid) => {
      if (valid) {
        let res: any = {};
        if (this.type === "添加") {
          this.formData.id = 0;
          res = await addNews(this.formData);
        } else {
          res = await editNews(this.formData);
        }
        if (res.code === 200) {
          this.isEditing = false;
          (this.$refs[formName] as ElForm).resetFields();
          this.formData.contentText = "";
          this.getDiseaseList();
        }
      } else {
        return false;
      }
    });
  }
  public clearName() {
    this.form.tenantId = "";
  }
}
